module.exports = __webpack_public_path__ + "img/1f628.278eb80.svg";